import {
  effectiveProfile,
  isInternalAIConfig,
  type GameAction,
  type SerializableAIConfig,
} from '@texas42/game-runtime';
import {
  DEFAULT_MIN_BID_DELAY_MS,
  DEFAULT_MIN_PLAY_DELAY_MS,
  PROGRESSIVE_PLAY_SUBMIT_DELAY_MS,
} from './action-submit-schedule-constants.js';

export {
  DEFAULT_MIN_BID_DELAY_MS,
  DEFAULT_MIN_PLAY_DELAY_MS,
  PROGRESSIVE_DEPTH_PLAY_SCHEDULE_PREDICATE,
  PROGRESSIVE_PLAY_SUBMIT_DELAY_MS,
} from './action-submit-schedule-constants.js';

/** One turn-start schedule shared by worker, fallback, and main-thread AI. */
export function actionSubmitDelayMs(
  actionType: GameAction['type'],
  config: SerializableAIConfig,
  overrides: { minPlayDelayMs?: number; minBidDelayMs?: number } = {},
): number {
  if (actionType === 'play') {
    if (overrides.minPlayDelayMs !== undefined) return overrides.minPlayDelayMs;
    if (isInternalAIConfig(config)) return DEFAULT_MIN_PLAY_DELAY_MS;
    const profile = effectiveProfile(config);
    return profile.playingMaximumWorlds > profile.playingMinimumWorlds
      ? PROGRESSIVE_PLAY_SUBMIT_DELAY_MS
      : DEFAULT_MIN_PLAY_DELAY_MS;
  }
  if (actionType === 'bid' || actionType === 'pass') {
    return overrides.minBidDelayMs ?? DEFAULT_MIN_BID_DELAY_MS;
  }
  return 0;
}

export function remainingSubmitDelayMs(scheduledAt: number, delayMs: number): number {
  return Math.max(0, delayMs - (Date.now() - scheduledAt));
}
